import { LargeMailingModel } from './../../../models/report/report-large-mailing.model';
import  { MutationTree } from "vuex";
import ReportStoreTypes from "./define-types.store";
import {
  ILargeMailingModel,
  ReportSendEmailUpdateModel
} from "../../../models/report";
import { ILargeMailingState } from './states.store';
import { deepClone } from 'fast-json-patch/lib/core';

const largeMailingMutations: MutationTree<ILargeMailingState> = <MutationTree<
ILargeMailingState
  >>{
    /** STORE TO STATE */
    [ReportStoreTypes.Set.STORE_LARGEMAILING]: (
      state: ILargeMailingState,
      model: ILargeMailingModel
    ) => {
      state.largeMailing = model;
    },

    /** UPDATE STATE */
    [ReportStoreTypes.Set.UPDATE_LARGEMAILING]: (
      state: ILargeMailingState,
      updateModel: ReportSendEmailUpdateModel
    ) => {
      if (!state.largeMailing) return;
      state.largeMailing[updateModel.Field] = updateModel.Value;
    },

    /** DELETE STATE */
    [ReportStoreTypes.Set.DELETE_LARGEMAILING]: (state: ILargeMailingState) => {
      state.largeMailing = null;
    },

    /** INIT STATE */
    [ReportStoreTypes.Set.INIT_LARGEMAILING]: (state: ILargeMailingState, moduleId: number) => {
      state.largeMailing = new LargeMailingModel();
      state.largeMailing.Module = moduleId;
    },
    /** DEMAND INFOS */
    [ReportStoreTypes.Set.DEMAND_INFOS]: (state: ILargeMailingState, info) => {
      state.demandInfos = deepClone(info);
    },
    /** PERSON INFOS */
    [ReportStoreTypes.Set.PERSON_INFOS]: (state: ILargeMailingState, info) => {
      state.personInfos = deepClone(info);
    },
    /** UPDATE ITEM TO ARRAY FIELD STATE */
    [ReportStoreTypes.Set.UPDATE_iTEM_ARRAY_FIELD_LARGEMAILING]: (
      state: ILargeMailingState,
      updateModel: ReportSendEmailUpdateModel
    ) => {
      if (!state.largeMailing) return;

      // REMOVE ALL OLDS ITEM
      let items = state.largeMailing[updateModel.Field];
      if (items != null && items.length > 0) {
        for (let index = 0; index < items.length; index++) {
          state.largeMailing[updateModel.Field].splice(index, 1);
        }
      }

      // UPDATE NEW ITEMS
      state.largeMailing[updateModel.Field] = updateModel.Value;
    },
  };

export default largeMailingMutations;
